// import axios from "axios";
import instance from '../axios/index.ts'
// import instance8001 from '../axios/http.ts'

interface GetDataType {
  data: any
  code: number
  function_name: string
  segmentid: number | string
  offset_point: number
  sample_points: number
  channel: number
  real_offset: number
  last_point: number
  remainder_points: number
}
interface FetchEhgType {
  data: any
  code: number
  function_name: string
  segmentid: number | string
  offset_point: number
  sample_points: number
  channel: number
  real_offset: number
  last_point: number[]
  remainder_points: number
}
interface FetchEucgType {
  result: string
  data: number[][]
  code: number
  function_name: string
  segmentid: number | string
  offset_point: number
  sample_points: number
  channel: number
  real_offset: number
  last_point: number[]
  remainder_points: number
}

interface FetchMhrType {
  function_name: string
  segmentid: string
  mhr: number
  code: number
}
interface FetchLeadsType {
  result: string
  function_name: string
  segmentid: string
  leads: number[]
  code: number
}
interface CreateSessionParmasType {
  funcname?: string
  hashack?: string
  subsystem_id?: string
  login_time?: string
  login_token?: string
}
interface CreateSessionType {
  result: string
  code: number
  function_name: string
  // challengehash: string
  sessionid: string
  // authorization: string
  // expirydate: string
  // module: string
  // module_uuid: string
  // firmware_version: string
}
interface CreateSegmentParmasType {
  funcname?: string
  sessionid: string
  segmentid: string
}
interface CreateSegmentType {
  code: number
  result: string
  function_name: string
  segmentid: string
  segment_endtime: string
}
interface EndSegmentParmasType {
  funcname?: string
  sessionid?: string
  segmentid?: string
  // subsystem_id?: string
}
interface EndSegmentType {
  code: number
  segmentid: string
  segment_endtime: string
}
interface StartSegmentParmasType {
  /** 子机id  */
  subsystem_id: number
  sessionid: string
  channels: number
  /**-1不会过期, 单位秒(s) */
  max_duration: -1 | 600
  signal_type: 'ehg' | 'eucg' | 'osg'
}
interface StartSegmentType {
  code: number
  result: string
  function_name: string
  segmentid: string
  segment_endtime: string
}
interface ActiveSegmentParmasType {
  subsystem_id: number
  sessionid: string
}
interface ActiveSegmentType {
  code: number
  start_time: string
  segmentid: string
  signal_type: 'ehg' | 'eucg' | 'osg'
  channels: number
  sample_rate_num: number
  sample_rate_dem: number
}

interface FetchUaParmasType {
  funcname?: string
  sessionid?: string
  segmentid?: number
}

interface FetchUaType {
  code: number
  message: string
  data: number[]
}

// export function login(data: any): Promise<GetDataType> {
//   return instance.post('/api/login_request', data)
// }

export function fetchData(data: any): Promise<GetDataType> {
  return instance.post('/api/fetch_data', data)
}

/**
 *  获取ecg数据
 * @param data
 * @returns
 */
export function fetchEhg(data: any): Promise<FetchEhgType> {
  return instance.post('/api/fetch_ehg', data)
}

/**
 * 获取eucg数据
 * @param data
 * @returns
 */
export function fetchEucg(data: any): Promise<FetchEucgType> {
  return instance.post('/api/fetch_eucg', data)
}

/**
 * 获取母亲心率数据
 * @param data
 * @returns
 */
export function fetchMhr(data: any): Promise<FetchMhrType> {
  return instance.post('/api/fetch_mhr', data)
}
/**
 * 获取电极状态
 * @param data
 * @returns
 */
export function fetchLeads(data: any): Promise<FetchLeadsType> {
  return instance.post('/api/fetch_leads', data)
}
// /**
//  * 创建会话
//  * @param data
//  * @returns
//  */
// export function createSession(data: CreateSessionParmasType): Promise<CreateSessionType> {
//   return instance.post('/api/login_request', data)
// }
// /**
//  * 创建会话
//  * @param data
//  * @returns
//  */
// export function createSession(data: CreateSessionParmasType): Promise<CreateSessionType> {
//   return instance.post('/api/login_response', data)
// }
/**
 * 创建会话
 * @param data
 * @returns
 */
export function createSession(data: CreateSessionParmasType): Promise<CreateSessionType> {
  return instance.post('/api/create_session', data)
}
/**
 *
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function createSegment(data: CreateSegmentParmasType): Promise<CreateSegmentType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/create_segment', data)
}
/**
 *
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function startSegment(data: StartSegmentParmasType): Promise<StartSegmentType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/start_segment', data)
}
/**
 *
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function endSegment(data: EndSegmentParmasType): Promise<EndSegmentType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/end_segment', data)
}
/**
 *
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function deleteSegment(data: EndSegmentParmasType): Promise<EndSegmentType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/delete_segment', data)
}
/**
 *获取活跃的segment
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function getActiveSegment(data: ActiveSegmentParmasType): Promise<ActiveSegmentType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/get_active_segment', data)
}
/**
 *获取ua数据
 * @param data
 * @returns
 */
// 导出一个函数，用于创建一个分段
export function fetchUa(data: FetchUaParmasType): Promise<FetchUaType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/fetch_ua', data)
}

interface ConfigHardwareParmasType {
  sessionid: string
  /** 采样率分子 */
  sample_rate_num: number
  /** 采样率分母,不输入默认是1 */
  sample_rate_dem: number
  /** 通道数 */
  channels: number
}
interface ConfigHardwareType {
  code: number
  sample_rate_num: number
  sample_rate_dem: number
  channels: number
}
/** */
export function configHardware(data: ConfigHardwareParmasType): Promise<ConfigHardwareType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/config_hardware', data)
}
interface configFliterParmasType {
  sessionid: string
  /** 宽带低频率，单位Hz，浮点数 */
  band_f0: number
  /** 宽带高频率，单位Hz，浮点数 */
  band_f1: number
  /** 通道数 */
  nortch: number
}
interface configFliterType {
  code: number
  band_f0: number
  band_f1: number
  nortch: number
}
/** */
export function configFliter(data: configFliterParmasType): Promise<configFliterType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/config_fliter', data)
}

interface fetchReportParmasType {
  sessionid: string
  segmentid: number
  start_time: number
  end_time: number
}
interface fetchReportType {
  code: number
  segmentid: string
  report_duration: string
  ehg_report: {
    PPV: string
    RMS: string
  }
  eucg_report: {
    EUCG_happend: number
    EUCG_Durations: number[]
    EUCG_Latency: number[]
  }
}
/** 获取导出报告*/
export function fetchReport(data: fetchReportParmasType): Promise<fetchReportType> {
  // 使用instance.post方法，向/api/create_segment接口发送post请求，参数为data
  return instance.post('/api/fetch_report', data)
}

// interface LoginParmasType {
//   username: string
// }
// interface LoginType {
//   request_time: string
//   challenge: string
// }
// /** 登录*/
// export function fetchLogin(data: LoginParmasType): Promise<LoginType> {
//   return instance.post('/api/fetch_report', data)
// }
/** 获取子机状态 */
export function getSubsysStatus(data: any): Promise<any> {
  return instance.post('/api/get_subsys_status', data)
}
